module.exports = __FOREMAN_VENDOR__PATTERNFLY_REACT_TABLE__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__PATTERNFLY_REACT_TABLE__"
// module id = @patternfly/react-table
// module chunks = 0